import { useCallback } from 'react';

import useAuth from '@hooks/useAuth';
import { Permission } from './permissions';

/**
 * 권한 판정 훅. **화면에서 권한을 묻는 유일한 방법이다.**
 *
 *     const can = useCan();
 *     if (can(PERMISSIONS.DOWNLOAD_EXCEL)) { ... }
 *
 * 권한 목록은 서버가 `/users/me` 로 계산해서 내려준다. 여기서 등급이나 기간을
 * 다시 계산하지 않는다 — 그러면 정책이 두 곳으로 갈라지고, 실제로 그래서
 * `includes('elite')` 가 elite 에게 pro 권한을 안 주는 버그가 있었다.
 *
 * 인자를 여러 개 주면 **전부** 가진 경우에만 참이다.
 */
export default function useCan(): (...required: Permission[]) => boolean {
  const { permissions } = useAuth();

  return useCallback(
    (...required: Permission[]) => required.every((permission) => permissions.includes(permission)),
    [permissions],
  );
}
